import { render, staticRenderFns } from "./IrisLoaderText.vue?vue&type=template&id=482bede6&"
import script from "./IrisLoaderText.vue?vue&type=script&lang=js&"
export * from "./IrisLoaderText.vue?vue&type=script&lang=js&"
import style0 from "./IrisLoaderText.vue?vue&type=style&index=0&id=482bede6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports